import { createFeatureSelector, createSelector } from '@ngrx/store';

import { MsalRoles } from '../../config';
import { MsalAuthState } from '../state';

export const getMsalState = createFeatureSelector<MsalAuthState.State>('msalAuth');

export const getError = createSelector(getMsalState, (state: MsalAuthState.State) => state.error);

export const getClientIDPCode = createSelector(
  getMsalState,
  (state: MsalAuthState.State) => state.idpCode
);

export const getRedirectState = createSelector(
  getMsalState,
  (state: MsalAuthState.State) => state.redirectState
);

export const getIdTokenClaims = createSelector(getMsalState, (state) => state.idTokenClaims);

export const getUserGuid = createSelector(
  getIdTokenClaims,
  (claims) => claims?.extension_PackageUserGuids
);

export const getPackageGuid = createSelector(
  getIdTokenClaims,
  (claims) => claims?.extension_PackageGuid
);

export const getIsUserVerified = createSelector(
  getIdTokenClaims,
  (claims) => claims?.role === MsalRoles.Verified
);

export const getLastVerifiedUserGuid = createSelector(
  getMsalState,
  (state: MsalAuthState.State) => state.lastVerifiedUserGuid
);

export const getIsLoading = createSelector(
  getMsalState,
  (state: MsalAuthState.State) => state.loading
);

export const selectVerifiedUserGuids = createSelector(
  getMsalState,
  (state: MsalAuthState.State) => state.verifiedUserGuids
);

export const getIsActiveAccountSet = createSelector(
  getMsalState,
  (state: MsalAuthState.State) => state.isActiveAccountSet
);
